import { render, staticRenderFns } from "./Dealerships.vue?vue&type=template&id=0d8fd4ba&scoped=true&"
import script from "./Dealerships.vue?vue&type=script&lang=ts&"
export * from "./Dealerships.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d8fd4ba",
  null
  
)

export default component.exports